import { useEffect } from "react";

type Props = {
  message: string;
  onClose: () => void;
};

export default function Toast({ message, onClose }: Props) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 2400);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  return (
    <div className="fixed bottom-8 left-1/2 z-[80] w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 animate-fade">
      <div className="flex items-center gap-2.5 rounded-md border border-primary-500/30 bg-background-100 px-4 py-3 text-sm text-foreground-900 shadow-none">
        <span className="flex h-5 w-5 items-center justify-center text-accent-500">
          <i className="ri-checkbox-circle-line text-base"></i>
        </span>
        <span className="flex-1 leading-relaxed">{message}</span>
        <button
          type="button"
          onClick={onClose}
          aria-label="关闭提示"
          className="flex h-6 w-6 cursor-pointer items-center justify-center text-foreground-500 hover:text-foreground-900"
        >
          <i className="ri-close-line text-sm"></i>
        </button>
      </div>
    </div>
  );
}